
<template>
  <el-table
    :data="contacts"
    stripe
  >
    <el-table-column
      label="Title"
      prop="carriercont_title"
      :formatter="(row, col, cellValue) => cellValue || '-'"
    />
    <el-table-column
      label="Name"
      prop="carriercont_name"
      :formatter="(row, col, cellValue) => cellValue || '-'"
    />
    <el-table-column
      label="Location"
      prop="carriercont_location"
      :formatter="(row, col, cellValue) => cellValue || '-'"
    />
    <el-table-column
      label="Phone"
      prop="carriercont_phone"
      :formatter="(row, col, cellValue) => cellValue || '-'"
    />
    <el-table-column
      label="Mobile"
      prop="carriercont_mobile"
      :formatter="(row, col, cellValue) => cellValue || '-'"
    />
    <el-table-column
      label="Email"
      prop="carriercont_email"
      :formatter="(row, col, cellValue) => cellValue || '-'"
    />
    <el-table-column
      label="Notes"
      prop="carriercont_notes"
      :formatter="(row, col, cellValue) => cellValue || '-'"
    />
    <el-table-column
      label="Inc Pickups"
      prop="carriercont_incpickups"
      :formatter="(row, col, cellValue) => (cellValue) ? 'Yes' : 'No' "
    />
    <el-table-column
      v-if="canUpdate || canDelete"
      label="Actions"
      align="right"
      width="150px"
    >
      <template slot-scope="scope">
        <el-button
          v-if="canUpdate"
          size="mini"
          @click.native="$emit('edit', scope.row)"
        >
          Edit
        </el-button>
        <el-button
          v-if="canDelete"
          size="mini"
          type="danger"
          @click.native="deleteContact(scope.$index, scope.row)"
        >
          Delete
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { UPDATE, DELETE } from '@/plugins/user'
export default {
  props: {
    contacts: {
      type: Array,
      required: true,
      default: Array
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'carrier_contact')
    },
    canDelete () {
      return this.$user.can(DELETE, 'carrier_contact')
    }
  },
  methods: {
    deleteContact (index, contact) {
      this.$confirm('Are you sure to delete this contact ?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        contact.delete(builder => {
          builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
        })
          .then(res => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.$emit('refresh'))
      }).catch(() => {})
    }
  }
}
</script>
